export const api = {
    apiUrl: process.env ? (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'https://vkd8e5af0i.execute-api.ap-southeast-1.amazonaws.com/dev') : 'https://vkd8e5af0i.execute-api.ap-southeast-1.amazonaws.com/dev',
}


